module.exports = __webpack_public_path__ + "media/images/front/top/minnna_premium_plus-e8f5afd3b202659ee8d2c40a4de4be87.jpeg";